@if (control && control.errors && (control.dirty || control.touched)) {
  <span
    class="error-con"
    >
    <!-- General Errors -->
    @if (control.errors.required) {
      <span class="error-span"
        ><small>{{ fieldName }} is required</small></span
        >
      }
      @if (control.errors.minlength) {
        <span class="error-span"
          ><small
          >Minimum of
          {{ control.errors.minlength.requiredLength }} characters</small
          >
        </span>
      }
      @if (control.errors.maxlength) {
        <span class="error-span"
          ><small
          >Maximum of
          {{ control.errors.maxlength.requiredLength }} characters</small
          >
        </span>
      }
      @if (control.errors.email) {
        <span class="error-span"
          ><small>Invalid email address</small></span
          >
        }
        @if (control.errors.max) {
          <span class="error-span"
            ><small>Value cannot exceed {{ control.errors.max.max }}</small>
          </span>
        }
        <!-- Custom Errors -->
        @if (control.errors.rosterSchoolIDRequired) {
          <span class="error-span"
            ><small
            >Roster School ID is required when Roster Type is selected</small
            ></span
            >
          }
          @if (control.errors.rosterTypeRequired) {
            <span class="error-span"
              ><small
              >Roster Type is required when Roster School ID is filled</small
              ></span
              >
            }
            @if (control.errors.rosterDistrictIDRequired) {
              <span class="error-span"
                ><small
                >Roster District ID is required when Roster Type is selected</small
                ></span
                >
              }
              @if (control.errors.pattern) {
                <span class="error-span"
                  ><small>Score must be a number between 1 and 9999</small>
                </span>
              }
              @if (control.errors.scorePossibleInvalid) {
                <span class="error-span"
                  ><small>Score Possible must be a number between 1 and 9999</small>
                </span>
              }
              @if (control.errors.whitespace) {
                <span class="error-span"
                  ><small>Input cannot only contain whitespace</small>
                </span>
              }
              @if (control.errors.invalidUrl) {
                <span class="error-span"
                  ><small>Input must be a valid URL</small>
                </span>
              }
              @if (control.errors.lowercase) {
                <span class="error-span"
                  ><small>First letter of name must be capitalized</small>
                </span>
              }
            </span>
          }
